































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';

import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { Site, SitesApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';

@Component({
	components: {
		RouterLinkButton,
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class SitesList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', label: 'Site Name', sortable: true },
			{ key: 'org.name', label: 'Controlling Organisation', sortable: false },
			{ key: 'address.fullAdr', label: 'Address', sortable: false },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Region',
			field: 'address.region',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Northland', value: 'Northland' },
				{ text: 'Auckland', value: 'Auckland' },
				{ text: 'Waikato', value: 'Waikato' },
				{ text: 'Bay of Plenty', value: 'Bay of Plenty' },
				{ text: 'Gisborne', value: 'Gisborne' },
				{ text: 'Taranaki', value: 'Taranaki' },
				{ text: 'Manawatu-Wanganui', value: 'Manawatu-Wanganui' },
				{ text: 'Wellington', value: 'Wellington' },
				{ text: 'Nelson-Tasman', value: 'Nelson-Tasman' },
				{ text: 'West Coast', value: 'West Coast' },
				{ text: 'Canterbury', value: 'Canterbury' },
				{ text: 'Otago', value: 'Otago' },
				{ text: 'Southland', value: 'Southland' },
			],
		},
		{
			label: 'Active',
			field: 'active',
			value: false,
			type: 'checkbox',
		},
	];

	public searchByOptions = [
		{ value: 'name', label: 'Search name only' },
		{ value: 'address.fullAdr', label: 'Search address only' },
	];
	public searchBy = { value: 'name', label: 'Search name only' };

	private api: SitesApi;

	constructor() {
		super();
		this.api = new SitesApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'site-datatable');
	}

	public clickTable(item: Site, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'sites.view',
				params: { siteId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'sites.view',
				params: { siteId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		// this.$bvToast.toast('Toast body content', {
		//   title: 'Default',
		//   variant: 'default',
		//   solid: true
		// });
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			filters.push({ field: this.searchBy.value, value: this.state.search });
			const response = await this.api.getSites(
				ApiUtils.queryOptions(filters, ctx, { params: { include: 'org,products,address' } }),
			);
			const body = response.data;

			data = body.data;
			this.state.totalRows = (body.meta && body.meta.total) || 0;
		} catch (e) {
			this.state.totalRows = 0;

			console.log(e);
			// throw e;
		}
		return data;
	}
}
